// extracted by mini-css-extract-plugin
module.exports = {"list":"brand-portfolio-list-content_list__I_z2M","listPreview":"brand-portfolio-list-content_listPreview__LVjM1","w100":"brand-portfolio-list-content_w100__4WCSW"};